import { useEffect } from 'react';
import { useCallbackRef } from '@restart/hooks';
import Swiper from 'swiper';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import classNames from 'classnames';
import { GalleryThumbnail } from '#advertDetail/components/gallery/thumbnail/GalleryThumbnail';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { useGalleryContext } from '#advertDetail/components/gallery';
import galleryThumbnailListCss from '../../../assets/gallery/gallery-thumbnail-list.module.scss';

const GalleryThumbnailList = () => {
  const {
    advert: {
      photos,
    },
  } = useAdvertDetailContext();
  const [container, setContainer] = useCallbackRef<HTMLDivElement>();
  const { refSwiperThumbnailList, activePhotoIndex } = useGalleryContext();

  useEffect(() => {
    if (!refSwiperThumbnailList.current) {
      return;
    }

    refSwiperThumbnailList.current.slideToLoop(activePhotoIndex);
  }, [activePhotoIndex, refSwiperThumbnailList]);

  useEffect(() => {
    if (!container) {
      return;
    }

    refSwiperThumbnailList.current = new Swiper(container, {
      slidesPerView: 6,
      spaceBetween: 6,
      loop: photos.length > 6,
      wrapperClass: swiperCss.swiper__wrapper,
      slideClass: swiperCss.swiper__slide,
      breakpoints: {
        992: {
          spaceBetween: 10,
        },
      },
    });
  }, [container, photos.length, refSwiperThumbnailList]);

  if (photos.length < 2) {
    return null;
  }

  const galleryThumbList = photos.map((photo, index) => (
    <GalleryThumbnail key={photo.id} photo={photo} index={index} />
  ));

  return (
    <div className={galleryThumbnailListCss.galleryThumbnailList} ref={setContainer}>
      <div className={classNames(swiperCss.swiper__wrapper, galleryThumbnailListCss.galleryThumbnailList__wrapper)}>
        {galleryThumbList}
      </div>
    </div>
  );
};

export { GalleryThumbnailList };
